import { defineComponent as _defineComponent } from 'vue'
import { provide } from "vue";
import { DefaultApolloClient } from "@vue/apollo-composable";
import apolloClient from "@/apollo";
import { NConfigProvider } from "naive-ui";
import type { GlobalThemeOverrides } from "naive-ui";
import AppInner from "@/app/AppInner.vue";
import { createHoverColor, createPressedColor } from "@/utils/theming";
import BroadcastWrapper from "@/components/BroadcastWrapper.vue";
import { initTraces } from "./useOpentelemetryTraces";
import { initMetrics } from "./useOpentelemetryMetrics";
import { initWorkers } from "@/perspective";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {
  __expose();

initTraces();
initMetrics();
initWorkers();

// https://github.com/TuSimple/naive-ui/blob/main/themes/tusimple/src/theme-overrides-light.ts
const themeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: "#fa7156",
    primaryColorHover: createHoverColor("#fa7156"),
    primaryColorPressed: createPressedColor("#fa7156"),
  },
};
provide(DefaultApolloClient, apolloClient);

const __returned__ = { themeOverrides, provide, get DefaultApolloClient() { return DefaultApolloClient }, get apolloClient() { return apolloClient }, get NConfigProvider() { return NConfigProvider }, AppInner, get createHoverColor() { return createHoverColor }, get createPressedColor() { return createPressedColor }, BroadcastWrapper, get initTraces() { return initTraces }, get initMetrics() { return initMetrics }, get initWorkers() { return initWorkers } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})